export default __webpack_public_path__ + "static/media/refresh.12db3c1b.svg";